<acs-modal 
  [isOpen]="isOpen" 
  title="Publish Announcement"
  size="large"
  (modalClosed)="onModalClose()">
  
  <div class="announcement-modal">
    
    <!-- Progress Steps -->
    <div class="announcement-modal__progress">
      <div class="announcement-modal__steps">
        <div 
          *ngFor="let step of [1,2,3]; let i = index"
          class="announcement-modal__step"
          [class.announcement-modal__step--active]="currentStep === step"
          [class.announcement-modal__step--completed]="currentStep > step"
          (click)="goToStep(step)">
          <div class="announcement-modal__step-number">{{ step }}</div>
          <div class="announcement-modal__step-label">
            {{ step === 1 ? 'Content' : step === 2 ? 'Settings' : 'Review' }}
          </div>
        </div>
      </div>
      <div class="announcement-modal__progress-bar">
        <div 
          class="announcement-modal__progress-fill"
          [style.width.%]="(currentStep / totalSteps) * 100">
        </div>
      </div>
    </div>

    <!-- Step 1: Content Creation -->
    <div *ngIf="currentStep === 1" class="announcement-modal__step-content">
      <div class="announcement-modal__section">
        <h3 class="announcement-modal__section-title">📝 Announcement Content</h3>
        
        <!-- Title -->
        <div class="announcement-modal__field">
          <label class="announcement-modal__label" for="announcementTitle">
            Title <span class="announcement-modal__required">*</span>
          </label>
          <input 
            id="announcementTitle"
            type="text" 
            class="announcement-modal__input"
            [(ngModel)]="announcementData.title"
            placeholder="Enter announcement title..."
            maxlength="200">
          <div class="announcement-modal__field-info">
            {{ announcementData.title.length }}/200 characters
          </div>
        </div>

        <!-- Rich Text Toolbar -->
        <div class="announcement-modal__field">
          <label class="announcement-modal__label" for="announcementContent">
            Message <span class="announcement-modal__required">*</span>
          </label>
          
          <div class="announcement-modal__editor-toolbar">
            <button 
              type="button"
              class="announcement-modal__toolbar-btn"
              (click)="formatText('bold')"
              title="Bold">
              <strong>B</strong>
            </button>
            <button 
              type="button"
              class="announcement-modal__toolbar-btn"
              (click)="formatText('italic')"
              title="Italic">
              <em>I</em>
            </button>
            <button 
              type="button"
              class="announcement-modal__toolbar-btn"
              (click)="formatText('underline')"
              title="Underline">
              <u>U</u>
            </button>
            <div class="announcement-modal__toolbar-separator"></div>
            <button 
              type="button"
              class="announcement-modal__toolbar-btn"
              (click)="formatText('bullet')"
              title="Bullet Point">
              •
            </button>
          </div>

          <textarea 
            id="announcementContent"
            class="announcement-modal__textarea"
            [(ngModel)]="announcementData.content"
            (input)="onContentInput($event)"
            placeholder="Enter your announcement message here...

You can use basic formatting:
**Bold text**
*Italic text*
__Underlined text__
• Bullet points"
            rows="12"></textarea>
          <div class="announcement-modal__field-info">
            {{ announcementData.content.length }} characters
          </div>
        </div>

        <!-- Priority Selection -->
        <div class="announcement-modal__field">
          <label class="announcement-modal__label">Priority Level</label>
          <div class="announcement-modal__priority-grid">
            <div 
              *ngFor="let priority of priorityOptions"
              class="announcement-modal__priority-option"
              [class.announcement-modal__priority-option--selected]="announcementData.priority === priority.value"
              (click)="announcementData.priority = $any(priority.value)">
              <div class="announcement-modal__priority-icon">{{ priority.icon }}</div>
              <div class="announcement-modal__priority-content">
                <div class="announcement-modal__priority-label">{{ priority.label }}</div>
                <div class="announcement-modal__priority-description">{{ priority.description }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Step 2: Settings & Targeting -->
    <div *ngIf="currentStep === 2" class="announcement-modal__step-content">
      <div class="announcement-modal__section">
        <h3 class="announcement-modal__section-title">⚙️ Announcement Settings</h3>
        
        <!-- Target Chapters -->
        <div class="announcement-modal__field">
          <label class="announcement-modal__label">
            Target Chapters <span class="announcement-modal__required">*</span>
          </label>
          <div class="announcement-modal__chapter-selection">
            <div class="announcement-modal__selection-actions">
              <button 
                type="button"
                class="announcement-modal__selection-btn"
                (click)="selectAllChapters()">
                Select All
              </button>
              <button 
                type="button"
                class="announcement-modal__selection-btn"
                (click)="clearAllChapters()">
                Clear All
              </button>
              <span class="announcement-modal__selection-count">
                {{ announcementData.targetChapters.length }} of {{ selectedChapters.length }} selected
              </span>
            </div>
            
            <div class="announcement-modal__chapter-list">
              <div 
                *ngFor="let chapter of selectedChapters"
                class="announcement-modal__chapter-item"
                [class.announcement-modal__chapter-item--selected]="isChapterSelected(chapter)" >
                <div class="announcement-modal__chapter-checkbox">
                  <input 
                    type="checkbox" 
                    [checked]="isChapterSelected(chapter)"
                    (change)="toggleChapterSelection(chapter)">
                </div>
                <div class="announcement-modal__chapter-info" (click)="toggleChapterSelection(chapter)">
                  <div class="announcement-modal__chapter-name">{{ chapter.Name }}</div>
                  <div class="announcement-modal__chapter-details">
                    {{ chapter.CommitteeID }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Scheduling -->
        <div class="announcement-modal__field-group">
          <div class="announcement-modal__field">
            <label class="announcement-modal__label" for="publishDate">
              Publish Date <span class="announcement-modal__required">*</span>
            </label>
            <input 
              id="publishDate"
              type="datetime-local" 
              class="announcement-modal__input"
              [(ngModel)]="announcementData.publishDate">
          </div>

          <div class="announcement-modal__field">
            <label class="announcement-modal__label" for="expiryDate">
              Expiry Date (Optional)
            </label>
            <input 
              id="expiryDate"
              type="datetime-local" 
              class="announcement-modal__input"
              [(ngModel)]="announcementData.expiryDate">
          </div>
        </div>

      </div>
    </div>

    <!-- Step 3: Review & Confirm -->
    <div *ngIf="currentStep === 3" class="announcement-modal__step-content">
      <div class="announcement-modal__section">
        <h3 class="announcement-modal__section-title">👁️ Review Announcement</h3>
        
        <!-- Summary Overview -->
        <div class="announcement-modal__review-summary">
          <div class="announcement-modal__summary-card">
            <div class="announcement-modal__summary-title">📊 Announcement Summary</div>
            <div class="announcement-modal__summary-items">
              <div class="announcement-modal__summary-item">
                <span class="announcement-modal__summary-label">Title:</span>
                <span class="announcement-modal__summary-value">{{ announcementData.title }}</span>
              </div>
              <div class="announcement-modal__summary-item">
                <span class="announcement-modal__summary-label">Priority:</span>
                <span class="announcement-modal__summary-value">
                  {{ getPriorityOption(announcementData.priority)?.icon }} 
                  {{ getPriorityOption(announcementData.priority)?.label }}
                </span>
              </div>
              <div class="announcement-modal__summary-item">
                <span class="announcement-modal__summary-label">Target Chapters:</span>
                <span class="announcement-modal__summary-value">{{ announcementData.targetChapters.length }} chapter{{ announcementData.targetChapters.length === 1 ? '' : 's' }}</span>
              </div>
              <div class="announcement-modal__summary-item">
                <span class="announcement-modal__summary-label">Publish Date:</span>
                <span class="announcement-modal__summary-value">{{ announcementData.publishDate | date:'medium' }}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Preview Content -->
        <div class="announcement-modal__preview">
          <div class="announcement-modal__preview-title">Preview</div>
          <div class="announcement-modal__preview-content">
            <div class="announcement-modal__preview-header">
              <h4>{{ announcementData.title }}</h4>
              <div class="announcement-modal__preview-priority">
                {{ getPriorityOption(announcementData.priority)?.icon }} 
                {{ getPriorityOption(announcementData.priority)?.label }}
              </div>
            </div>
            <div class="announcement-modal__preview-body">
              <pre>{{ announcementData.content }}</pre>
            </div>
          </div>
        </div>

        <!-- Target Chapters List -->
        <div class="announcement-modal__target-list">
          <div class="announcement-modal__target-title">Target Chapters:</div>
          <div class="announcement-modal__target-chapters">
            <span 
              *ngFor="let chapter of announcementData.targetChapters; let last = last"
              class="announcement-modal__target-chapter">
              {{ chapter.Name }}{{ !last ? ', ' : '' }}
            </span>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Actions -->
    <div class="announcement-modal__actions">
      <div class="announcement-modal__actions-left">
        <acs-button 
          *ngIf="currentStep > 1"
          variant="secondary" 
          (clicked)="previousStep()">
          Previous
        </acs-button>
      </div>

      <div class="announcement-modal__actions-right">
        <acs-button 
          variant="text" 
          (clicked)="onModalClose()">
          Cancel
        </acs-button>

        <acs-button 
          *ngIf="currentStep < totalSteps"
          variant="primary" 
          (clicked)="nextStep()"
          [disabled]="!canProceedToStep(currentStep + 1)">
          Next
        </acs-button>

        <acs-button 
          *ngIf="currentStep === totalSteps"
          variant="primary" 
          (clicked)="publishAnnouncement()"
          [disabled]="!canPublish() || isPublishing"
          [loading]="isPublishing">
          {{ isPublishing ? 'Publishing...' : 'Publish Announcement' }}
        </acs-button>
      </div>
    </div>

  </div>
</acs-modal>